import { render, staticRenderFns } from "./SubNavigationOrderTabs.vue?vue&type=template&id=88775a36&"
import script from "./SubNavigationOrderTabs.vue?vue&type=script&lang=ts&"
export * from "./SubNavigationOrderTabs.vue?vue&type=script&lang=ts&"
import style0 from "./SubNavigationOrderTabs.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports